import './statusselect.css';

import { Component } from 'react';

import PropTypes from 'prop-types';
import Dropdown from 'react-dropdown';
import { colorMapping, appStatusType } from '../../../utils/enums';
import auth from '../../../utils/auth';
import { ATSCandidateListTestIds } from 'data-testids/ATS';

function getStatusSelectTestId(statusType, source) {
  if (statusType === appStatusType.hiring_pool) {
    return ATSCandidateListTestIds.STATUS_SELECT;
  }
  if (source === 'Nimble Connect') {
    return ATSCandidateListTestIds.STATUS_SELECT_CONNECT;
  }
  if (source === 'discover') {
    return ATSCandidateListTestIds.STATUS_SELECT_DISCOVER;
  }
  return ATSCandidateListTestIds.STATUS_SELECT;
}

export default class StatusSelect extends Component {
  constructor(props) {
    super(props);
    this.isSchoolAdmin = auth.isSchoolAdmin();
  }

  static propTypes = {
    application: PropTypes.object.isRequired,
    statusOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
    toggleStatus: PropTypes.func.isRequired,
  };

  render() {
    let status = this.props.application?.new_status;

    let color = colorMapping[status.color];

    let disabled =
      this.isSchoolAdmin &&
      (status.status_type === appStatusType.hired ||
        status.status_type === appStatusType.onboarding)
        ? true
        : false;

    const source = this.props.application?.source
      ? this.props.application?.source.value
      : this.props.application?.application_source;

    return (
      <div
        className="status-select"
        data-testid={getStatusSelectTestId(status.status_type, source)}
      >
        <div data-testid="select-container">
          <Dropdown
            options={this.props.statusOptions}
            onChange={(option) => this.props.toggleStatus(option)}
            value={status.label}
            className={`new-status-dropdown ${color} disabled-${disabled}`}
            disabled={disabled}
          />
        </div>
      </div>
    );
  }
}
